module.exports = {"130607001":"惠阳街道","130607100":"满城镇","130607101":"大册营镇","130607102":"神星镇","130607103":"南韩村镇","130607104":"方顺桥镇","130607105":"于家庄镇","130607203":"要庄乡","130607204":"白龙乡","130607205":"石井乡","130607206":"坨南乡","130607207":"刘家台乡","130607400":"河北满城经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130607.json
// module id = 241
// module chunks = 0